import {
  Alert,
  Box,
  Button,
  CircularProgress,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  List,
  ListItem,
  Modal,
  ModalClose,
  ModalDialog,
  Option,
  Select,
  Sheet,
  Switch,
  Tab,
  TabList,
  TabPanel,
  Table,
  Tabs,
} from "@mui/joy";
import React from "react";
import ButtonOn from "../../images/ButtonOn/buttonOnGif1.gif";
import ButtonOff from "../../images/ButtonOff/buttonOffGif1.gif";
import ButtonErr from "../../images/Error/ErrorGif.gif";
import ButtonSuc from "../../images/Success/SuccessGif.gif";
import { useState } from "react";
import { useEffect } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Paper, Typography } from "@mui/material";
import TimeStamp from "../Cargo/TimeStamp";

function labelDisplayedRows({ from, to, count }) {
  return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
}

export default function ({ props, props2 }) {
  const [flag, setFlag] = useState("N");
  const [resData, setResData] = useState([]);
  const [errData, setErrData] = useState([]);
  const [sucData, setSucData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [fileText, setFileText] = useState();
  const [layout, setLayout] = useState(undefined);
  const [scroll, setScroll] = useState(true);
  const [load, setLoad] = useState(false);
  const apiUrl = process.env.REACT_APP_APIMFCS;
  const apiUrl2 = process.env.REACT_APP_APIIT;

  const flagChange = async (flag2) => {
    setLoad(true);
    try {
      const response = await fetch(
        `${apiUrl}/edi/flag?key=aactEdiIT1399!@%23&flags=${flag2}`
      );
      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const res = await response.json();

      if (res.length === 0) {
        props({ openErr: 2, detail: "No Data" });
      } else {
        if (res.code === "S") {
          props({ openSuc: 1 });
          getMfcsFlag();
        } else {
          props({ openErr: 2, detail: "서버실행에러" });
          getMfcsFlag();
        }
      }
    } catch (Error) {
      props({ openErr: 2, detail: "서버실행에러 : " + Error });
    }
    setLoad(false);
  };

  const listSearch = async () => {
    try {
      const response = await fetch(`${apiUrl2}/monitering/search?type=mfcs`);
      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const res = await response.json();

      if (res.length === 0) {
        props({ openErr: 2, detail: "No Data" });
      } else {
        const data = res.map((row, index) => ({
          id: index,
          value1: row.value1,
          value2: row.value2,
          value3: row.value3,
          value4: row.value4,
          value5: row.value5,
          value6: row.value6,
          value7: row.value7,
          value8: row.value8,
          value9: row.value9,
        }));
        setResData(data);
      }
    } catch (Error) {
      props({ openErr: 2, detail: "서버실행에러 : " + Error });
    }
  };

  const getMfcsFlag = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/edi/mfcsflag?key=aactEdiIT1399!@%23`
      );
      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const res = await response.text();

      setFlag(res);
    } catch (Error) {
      props({ openErr: 2, detail: "서버실행에러 : " + Error });
    }
  };

  useEffect(() => {
    getMfcsFlag();
  }, []);
  useEffect(() => {
    const intervalId = setInterval(() => {
      listSearch();
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  useEffect(() => {
    if (props2.btn === "Y") {
      getMfcsFlag();
    } else if (props2.btn === "N") {
      flagChange("N");
    }
  }, [props2]);
  useEffect(() => {
    setErrData(resData.filter((item) => item.value5 === "E"));
    setSucData(resData.filter((item) => item.value5 === "S"));
  }, [resData]);

  const clickOnEvent = () => {
    props({ openErr: 1, detail: "MFCS서버를 종료하시겟습니까?" });
  };
  const clickOffEvent = () => {
    flagChange("Y");
  };
  const handleChangeRowsPerPage = (event, newValue) => {
    setRowsPerPage(parseInt(newValue.toString(), 10));
    setPage(0);
  };
  const getLabelDisplayedRowsTo = (status) => {
    if (status === "suc") {
      if (sucData.length === -1) {
        return (page + 1) * rowsPerPage;
      }
      return rowsPerPage === -1
        ? sucData.length
        : Math.min(sucData.length, (page + 1) * rowsPerPage);
    } else if (status === "err") {
      if (errData.length === -1) {
        return (page + 1) * rowsPerPage;
      }
      return rowsPerPage === -1
        ? errData.length
        : Math.min(errData.length, (page + 1) * rowsPerPage);
    }
  };
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const rowGetDetail = async (row) => {
    setLoad(true);
    try {
      const response = await fetch(
        `${apiUrl2}/monitering/filedetail?path=${encodeURIComponent(
          row.value7
        )}`
      );
      if (!response.ok) {
        throw new Error(`${response.statusText}`);
      }
      const res = await response.text();

      if (res.length === 0) {
        props({ openErr: 2, detail: "No Data" });
      } else {
        setFileText(res);
        setLayout("center");
        setLoad(false);
      }
    } catch (Error) {
      props({ openErr: 2, detail: "서버실행에러 : " + Error });
    }
  };

  return (
    <Box>
      <Tabs aria-label="Basic tabs" defaultValue={0}>
        <TabList>
          <Tab>Success</Tab>
          <Tab>Error</Tab>

          {flag === "Y" ? (
            <img
              src={ButtonOn}
              width={80}
              style={{ marginLeft: "37%", marginRight: 1, paddingBottom: 3 }}
              onClick={(e) => (clickOnEvent(), e.stopPropagation())}
            />
          ) : (
            <img
              src={ButtonOff}
              width={80}
              style={{ marginLeft: "37%", marginRight: 1, paddingBottom: 3 }}
              onClick={(e) => (clickOffEvent(), e.stopPropagation())}
            />
          )}

          <Paper
            sx={{
              width: 240,
              height: 35,
              backgroundColor: "#f1f3f5",
              paddingTop: 0.7,
              marginLeft: "auto",
              marginRight: 0,
            }}
            elevation={12}
          >
            <TimeStamp />
          </Paper>
        </TabList>
        <TabPanel value={1}>
          <Table
            size="sm"
            sx={{
              "--TableCell-height": "30px",
              "--TableCell-paddingX": "0px",
              "--TableCell-paddingY": "0px",
              marginLeft: 7,
              width: "90%",
            }}
            aria-label="basic table"
            hoverRow
          >
            <thead>
              <tr>
                <th style={{ width: "100px" }}>일시</th>
                <th>편번</th>
                <th style={{ width: "120px" }}>날짜</th>
                <th>파일명</th>
                <th style={{ width: "120px" }}>에러위치</th>
                <th style={{ width: "120px" }}>상태</th>
                <th>에러내용</th>
              </tr>
            </thead>
            <tbody>
              {errData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <tr
                    key={row.id}
                    onClick={(e) => (e.stopPropagation(), rowGetDetail(row))}
                  >
                    <td>{row.value2}</td>
                    <td>{row.value8}</td>
                    <td>{row.value9}</td>
                    <td>{row.value3}</td>
                    <td>{row.value4}</td>
                    <td style={{ paddingTop: 6 }}>
                      {row.value5 === "E" ? (
                        <img width={80} src={ButtonErr}></img>
                      ) : (
                        <img width={80} src={ButtonSuc}></img>
                      )}
                    </td>
                    <td>{row.value6}</td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={7}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      justifyContent: "flex-end",
                    }}
                  >
                    <FormControl orientation="horizontal" size="sm">
                      <FormLabel>Rows per page:</FormLabel>
                      <Select
                        onChange={handleChangeRowsPerPage}
                        value={rowsPerPage}
                      >
                        <Option value={5}>5</Option>
                        <Option value={10}>10</Option>
                        <Option value={15}>15</Option>
                      </Select>
                    </FormControl>
                    <Typography textAlign="center" sx={{ minWidth: 80 }}>
                      {labelDisplayedRows({
                        from: errData.length === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo("err"),
                        count: errData.length === -1 ? -1 : errData.length,
                      })}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        size="sm"
                        color="neutral"
                        variant="outlined"
                        disabled={page === 0}
                        onClick={() => handleChangePage(page - 1)}
                        sx={{ bgcolor: "background.surface" }}
                      >
                        <KeyboardArrowLeftIcon />
                      </IconButton>
                      <IconButton
                        size="sm"
                        color="neutral"
                        variant="outlined"
                        disabled={
                          sucData.length !== -1
                            ? page >=
                              Math.ceil(errData.length / rowsPerPage) - 1
                            : false
                        }
                        onClick={() => handleChangePage(page + 1)}
                        sx={{ bgcolor: "background.surface" }}
                      >
                        <KeyboardArrowRightIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </td>
              </tr>
            </tfoot>
          </Table>
        </TabPanel>
        <TabPanel value={0}>
          <Table
            size="sm"
            sx={{
              "--TableCell-height": "30px",
              "--TableCell-paddingX": "0px",
              "--TableCell-paddingY": "0px",
              marginLeft: 7,
              width: "90%",
            }}
            aria-label="basic table"
            hoverRow
          >
            <thead>
              <tr>
                <th style={{ width: "100px" }}>일시</th>
                <th>편번</th>
                <th style={{ width: "120px" }}>날짜</th>
                <th>파일명</th>
                <th style={{ width: "120px" }}>진행위치</th>
                <th style={{ width: "120px" }}>상태</th>
              </tr>
            </thead>
            <tbody>
              {sucData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <tr
                    key={row.id}
                    onClick={() => {
                      rowGetDetail(row);
                    }}
                  >
                    <td>{row.value2}</td>
                    <td>{row.value8}</td>
                    <td>{row.value9}</td>
                    <td>{row.value3}</td>
                    <td>{row.value4}</td>
                    <td style={{ paddingTop: 6 }}>
                      {row.value5 === "E" ? (
                        <img width={90} src={ButtonErr}></img>
                      ) : (
                        <img width={90} src={ButtonSuc}></img>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={6}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      justifyContent: "flex-end",
                    }}
                  >
                    <FormControl orientation="horizontal" size="sm">
                      <FormLabel>Rows per page:</FormLabel>
                      <Select
                        onChange={handleChangeRowsPerPage}
                        value={rowsPerPage}
                      >
                        <Option value={5}>5</Option>
                        <Option value={10}>10</Option>
                        <Option value={15}>15</Option>
                      </Select>
                    </FormControl>
                    <Typography textAlign="center" sx={{ minWidth: 80 }}>
                      {labelDisplayedRows({
                        from: sucData.length === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo("suc"),
                        count: sucData.length === -1 ? -1 : sucData.length,
                      })}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        size="sm"
                        color="neutral"
                        variant="outlined"
                        disabled={page === 0}
                        onClick={() => handleChangePage(page - 1)}
                        sx={{ bgcolor: "background.surface" }}
                      >
                        <KeyboardArrowLeftIcon />
                      </IconButton>
                      <IconButton
                        size="sm"
                        color="neutral"
                        variant="outlined"
                        disabled={
                          sucData.length !== -1
                            ? page >=
                              Math.ceil(sucData.length / rowsPerPage) - 1
                            : false
                        }
                        onClick={() => handleChangePage(page + 1)}
                        sx={{ bgcolor: "background.surface" }}
                      >
                        <KeyboardArrowRightIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </td>
              </tr>
            </tfoot>
          </Table>
        </TabPanel>
      </Tabs>
      <Modal
        open={!!layout}
        onClose={() => {
          setLayout(undefined);
        }}
      >
        <ModalDialog layout={layout}>
          <ModalClose />
          <DialogTitle>fileText</DialogTitle>
          <List
            sx={{
              overflow: scroll ? "scroll" : "initial",
              mx: "calc(-1 * var(--ModalDialog-padding))",
              px: "var(--ModalDialog-padding)",
            }}
          >
            {[...Array(100)].map((item, index) => (
              <ListItem key={index}>{fileText}</ListItem>
            ))}
          </List>
        </ModalDialog>
      </Modal>
      <Modal
        sx={{
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          display: "flex",
        }}
        open={load}
      >
        <CircularProgress variant="soft" />
      </Modal>
    </Box>
  );
}
